import { render, staticRenderFns } from "./adsSystem.vue?vue&type=template&id=390dd816&scoped=true&"
import script from "./adsSystem.vue?vue&type=script&lang=js&"
export * from "./adsSystem.vue?vue&type=script&lang=js&"
import style0 from "./adsSystem.vue?vue&type=style&index=0&id=390dd816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dd816",
  null
  
)

export default component.exports